import { render, staticRenderFns } from "./staff-table.vue?vue&type=template&id=78eb5b5e&"
import script from "./staff-table.vue?vue&type=script&lang=js&"
export * from "./staff-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "staff-table.vue"
export default component.exports